/* eslint-disable semi */

import SanityBlockContent from './sanitySchema/sanityBlockContent';
import SanityImage from './sanitySchema/sanityImage';
import Person from './person';
import Department from './department';

export enum StoryType {
  Story,
  VideoPublication
}

export default interface Story {
  id: string;
  key: string;
  createdAt: Date;
  updatedAt: Date;
  storyType: StoryType;
  frontPage: boolean;
  title: string;
  slug: string;
  excerpt: string;
  content: SanityBlockContent;
  department: Department;
  image: SanityImage;
  author: Person;
  publishedDate: Date;
  updatedDate: Date;
  facebookQuote: string;
  facebookHashtag: string;
  twitterHashtags: Array<string>;
  twitterVia: string;
  otherWebsiteUrl: string;
  otherWebsiteTitle: string;
  emailSubject: string;
  emailBody: string;
}
